import component from './projectsResave.vue'

export default component
